import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "task-d" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "tw-mb-[7px] tw-min-h-[31px]"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "sf-btn-primary"
}, "Check", -1)
const _hoisted_6 = {
  key: 1,
  class: "result"
}
const _hoisted_7 = { class: "tw-inline-block" }
const _hoisted_8 = { class: "tw-inline-block tw-relative tw-top-0 tw-left-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mobile_keyboard = _resolveComponent("mobile-keyboard")!
  const _component_ResultMark = _resolveComponent("ResultMark")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmitForm && _ctx.onSubmitForm(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["input-field question", { mobile: _ctx.isMobile }])
      }, [
        (_ctx.step == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.isMobile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.inputValue), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
                      ref: "inputField",
                      autocomplete: "off",
                      autocorrect: "off",
                      autocapitalize: "off",
                      spellcheck: "false",
                      class: "tw-border-[3px] tw-border-solid tw-border-primary tw-pt-[14px] tw-pb-[8px] tw-px-[10px] tw-mb-[30px] tw-w-[400px] tw-overflow-hidden tw-text-nowrap tw-text-primary tw-bg-primaryvlt active:tw-outline-none focus-visible:tw-outline-none tw-rounded-xl"
                    }, null, 512), [
                      [_vModelText, _ctx.inputValue]
                    ])
                  ])),
              _hoisted_5,
              (_ctx.isMobile)
                ? (_openBlock(), _createBlock(_component_mobile_keyboard, {
                    key: 2,
                    modelValue: _ctx.inputValue,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputValue) = $event))
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.inputValue), 1),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_ResultMark, {
                  result: _ctx.result > 0,
                  rightClassName: "tw-inline",
                  wrongClassName: "tw-inline"
                }, null, 8, ["result"])
              ])
            ]))
      ], 2)
    ], 32)
  ]))
}